import { Provider } from '@angular/core';
import { AUTH_API } from './data-access/auth-api.port';
import { AuthApiService } from './data-access/auth-api.service';
import { AuthService } from './services/auth.service';

export const AUTH_PROVIDERS: Provider[] = [
  AuthService,
  { provide: AUTH_API, useClass: AuthApiService },
];
